// import React from 'react';
import { useTranslation } from 'react-i18next';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
            {t('privacy.title')}
          </h1>
          
          <div className="space-y-8 text-gray-600">
            {/* Introduction */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                {t('privacy.introduction.title')}
              </h2>
              <p className="mb-4">{t('privacy.introduction.description')}</p>
            </section>

            {/* Data Controller */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                {t('privacy.dataController.title')}
              </h2>
              <p className="mb-4">{t('privacy.dataController.content')}</p>
            </section>

            {/* Data Collection */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                {t('privacy.dataCollection.title')}
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                {['personal', 'usage', 'technical'].map((item) => (
                  <li key={item}>{t(`privacy.dataCollection.items.${item}`)}</li>
                ))}
              </ul>
            </section>

            {/* Data Usage */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                {t('privacy.dataUsage.title')}
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                {['service', 'improvement', 'communication'].map((item) => (
                  <li key={item}>{t(`privacy.dataUsage.items.${item}`)}</li>
                ))}
              </ul>
            </section>

            {/* User Rights */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                {t('privacy.userRights.title')}
              </h2>
              <p className="mb-4">{t('privacy.userRights.description')}</p>
              <ul className="list-disc pl-6 space-y-2">
                {['access', 'rectification', 'deletion', 'opposition', 'consent'].map((item) => (
                  <li key={item}>{t(`privacy.userRights.items.${item}`)}</li>
                ))}
              </ul>
            </section>

            {/* Security */}
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                {t('privacy.security.title')}
              </h2>
              <p className="mb-4">{t('privacy.security.description')}</p>
            </section>

            {/* Contact */}
            {/* <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                {t('privacy.contact.title')}
              </h2>
              <p className="mb-4">{t('privacy.contact.description')}</p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-medium">{t('privacy.contact.email')}</p>
                <p className="font-medium">{t('privacy.contact.address')}</p>
              </div>
            </section> */}

            {/* Last Update */}
            {/* <section className="border-t pt-6">
              <p className="text-sm text-gray-500 text-center">
                {t('privacy.lastUpdated', { date: new Date().toLocaleDateString() })}
              </p>
            </section> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;